
import { useEffect, useState } from 'react';
import PageTitle from '../../../components/Accessibility/PageTitle';
import './styles.css';
import { getEstatisticasPrograma, getTermoAltaCronicos } from '../../../services/SaudeBemEstar/GestaoDeCronicosService';
import DefaultText from '../../../components/Accessibility/DefaultText';
import { CircularProgress } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import WhiteContainer from '../../../components/Accessibility/WhiteContainer';
import { Estatisticas } from '../../../interfaces/entities/SaudeBemEstar/EncerramentoGC/Estatisticas';
import { useNavigate } from 'react-router-dom';
import ModalFeedBack from '../../../components/ModalFeedBack';

const Conclusao: React.FC = () => {

	const [stats, setStats] = useState<Estatisticas | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

	const navigate = useNavigate();

  useEffect(() => {
		setLoading(true);
		getEstatisticasPrograma()
			.then(response => {
				if (response) {
					setStats(response);
				}
			})
			.catch(error => {
        setShowErrorModal(true);
      })
			.finally(() => {
				setLoading(false);
			})
  }, []);

  const { contrastStyle, contrastMode, } = useAccessibility();

	const cleanedSvg = stats?.imagemBase64?.replace('data:image/svg;base64,', '') || '';

  return (
    <>
      <div className={`encerramento-page-container ${contrastMode ? 'contrast' : ''}`}>
        <PageTitle text='Obrigado!' />

				<img
					src={`data:image/svg+xml;base64,${cleanedSvg}`} alt={`Imagem para encerramento`}
					className='autoavaliacao-result-image'
				/>

				<span className="conclusao-text">Foi um prazer ter você durante esta jornada.</span>

					{
						loading ? <div style={{margin: '0 auto' }}> <CircularProgress />  </div>
						:	<WhiteContainer shadow>
								<div className="stats-container">
									<span style={contrastStyle}>Foram:</span>
									<div>
										<div className="stats-item"><span>{stats?.diasJuntos}</span><span>dias juntos</span></div>
										<div className="stats-item"><span>{stats?.atendimentos}</span><span>atendimentos</span></div>
										<div className="stats-item"><span>{stats?.eventos}</span><span>eventos</span></div>
									</div>
								</div>
							</WhiteContainer>
					}
					
					{
						stats && stats.textos.map(t => <DefaultText className="width-100pc max-width-660" text={t} />)
					}
				

				<DefaultButton text='Concluir' onClick={() => { navigate('/home') }} />

				<ModalFeedBack
          showModal={showErrorModal}
          handleShowModal={() => setShowErrorModal(false)}
          title="Ocorreu um erro"
          subTitle="Falha ao buscar informações. Tente novamente mais tarde."
          icon="error"
          showButtonModal
          textButton="Fechar"
          handleButtonModal={() => setShowErrorModal(false)}
      />  
      </div>
    </>
  )
}

export default Conclusao;